import { lazy } from 'react';

const CustomPlanificationsObjectives = lazy(() => import('./CustomPlanificationsObjectivesAll'));

export default CustomPlanificationsObjectives;
